import { call, put, take } from 'redux-saga/effects';

import { request } from '!core/api';
import { getBrowserLocales } from '!i18n/index';

import { i18nServices } from './i18n.services';
import { i18nSlice } from './i18n.slice';

const culturesWorker = function* () {
  try {
    let languagesRegions = yield call(i18nServices.availableCultures);

    languagesRegions = languagesRegions.map((el) => ({
      languageId: el.languageId,
      languageCode: el.languageCode,
      expression: el.expression,
      image: el.image,
      dateFormat: el.dateFormat,
      descr: el.descr,
    }));

    yield put(i18nSlice.actions.culturesSucess(languagesRegions));

    const currentLanguageCode =
      localStorage.getItem('userLanguageCode') || getBrowserLocales()[0];

    const current = languagesRegions.find((entry) =>
      entry.languageCode.startsWith(currentLanguageCode),
    );

    const userLanguage = {
      languageCode: current?.languageCode ?? 'pt-PT',
      languageId: current?.languageId ?? 'PRT',
    };

    request.setCulture(userLanguage);

    yield put(i18nSlice.actions.setUserLanguage(userLanguage));
  } catch (error) {
    yield put(i18nSlice.actions.culturesFailure(error));
  }
};
export const i18nSagas = function* () {
  while (true) {
    try {
      yield take(i18nSlice.actions.culturesRequest.type);
      yield call(culturesWorker);
    } catch (error) {
      yield put(i18nSlice.actions.culturesFailure(error));
    }
  }
};
